// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-33b83eb6] {\n  color: #6e478f;\n  font-weight: 600;\n}\n.content[data-v-33b83eb6] {\n  border: 2px solid #e4d7e9;\n  padding: 1em;\n}\n.content .audio-item[data-v-33b83eb6] {\n  width: 250px;\n}\n.content .audio-item .audio-label[data-v-33b83eb6] {\n  color: #586174;\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
